import React, { Component } from 'react';
import { inject } from 'mobx-react';
import PropTypes from 'prop-types';

@inject('settingsStore')
class AccessConnect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      success: true,
      loading: true,
    };
  }
  componentDidMount() {
    const { settingsStore, location } = this.props;
    window.opener.postMessage(
      { type: 'OAuthAccessCode', payload: location.query.code, client: location.query.client },
      '*',
    );
    settingsStore.connectionManagement
      .sendCodeAfterConnection(location.query.code, location.query.client)
      .then(() => settingsStore.browserHistory.replace('/'))
      .catch(() => this.setState({ success: false }))
      .then(() => this.setState({ loading: false }));
  }
  render() {
    const { success, loading } = this.state;
    return <div>{!loading && <div>{success ? 'Success!' : 'Failed to auth'}</div>}</div>;
  }
}

AccessConnect.propTypes = {
  location: PropTypes.object,
  settingsStore: PropTypes.object,
};

export default AccessConnect;
